module.exports = __webpack_public_path__ + "static/img/ziyuan2.d0bd9d3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/ziyuan2.gif
// module id = XcVQ
// module chunks = 0